import { DIV } from './DIV';
export var STATUS;
(function (STATUS) {
    STATUS[STATUS["loading"] = 0] = "loading";
    STATUS[STATUS["error"] = 1] = "error";
    STATUS[STATUS["unauth"] = 2] = "unauth";
    STATUS[STATUS["success"] = 3] = "success";
})(STATUS || (STATUS = {}));
var Component = /** @class */ (function () {
    function Component(props) {
        this.props = props;
    }
    Component.prototype.valueOf = function () {
        return this.el.valueOf();
    };
    Component.prototype.mount = function (el) {
        el.appendChild(this.valueOf());
    };
    Component.prototype.unmount = function (el) {
        el.removeChild(this.el.valueOf());
    };
    Component.prototype.toggleClassName = function (name, force) {
        this.el.toggleClassName(this.parseClassName(name), force);
    };
    Component.prototype.hasClassName = function (name) {
        return this.el.hasClassName(this.parseClassName(name));
    };
    Component.prototype.toggle = function (toggle, displayBlock) {
        if (displayBlock === void 0) { displayBlock = ''; }
        this.style.display = toggle ? displayBlock : 'none';
    };
    Component.prototype.appendChild = function (child) {
        this.el.appendChild(child);
    };
    Component.prototype.removeChild = function (child) {
        this.el.removeChild(child);
    };
    Object.defineProperty(Component.prototype, "style", {
        get: function () {
            return this.el.valueOf().style;
        },
        enumerable: false,
        configurable: true
    });
    Component.prototype.parseClassName = function (className) {
        if (className.indexOf('&') !== -1) {
            className = className.replace(/\&/g, this.name);
        }
        return className;
    };
    Component.prototype.DIV = function (props, childNodes) {
        if (typeof props === 'string') {
            props = this.parseClassName(props);
        }
        else if (props.className) {
            props.className = this.parseClassName(props.className);
        }
        return new DIV(props, childNodes);
    };
    // Стандартные состояния компонентов
    Component.prototype.toggleStatus = function (status) {
        this.toggleClassName('&_loading', status === STATUS.loading);
        this.toggleClassName('&_error', status === STATUS.error);
        this.toggleClassName('&_not-auth', status === STATUS.unauth);
    };
    Component.prototype.setStatusError = function () {
        this.toggleStatus(STATUS.error);
    };
    Component.prototype.setStatusLoading = function () {
        this.toggleStatus(STATUS.loading);
    };
    Component.prototype.setStatusUnauth = function () {
        this.toggleStatus(STATUS.unauth);
    };
    Component.prototype.setStatusSuccess = function () {
        this.toggleStatus(STATUS.success);
    };
    Component.prototype.isStatusLoading = function () {
        return this.hasClassName('&_loading');
    };
    Component.prototype.isStatusError = function () {
        return this.hasClassName('&_error');
    };
    return Component;
}());
export { Component };
